<template>
  <DelayHydration>
    <div class="breadcrumbs-wrapper">
      <ui-horizontal-scroll class="l-container">
        <ol
          itemscope
          itemtype="https://schema.org/BreadcrumbList"
          class="breadcrumbs"
        >
          <li
            v-for="(point, index) of data"
            :key="`breadcrumbs-item-${index}`"
            class="breadcrumbs-item body-m-regular"
            itemprop="itemListElement"
            itemscope=""
            itemtype="https://schema.org/ListItem"
          >
            <breadcrumbs-breadcrumbs-select
              v-if="point.nav && point.nav.length > 0"
              :list="point.nav"
              :last="index === data.length - 1"
            />

            <template v-else>
              <span
                v-if="!point.slug && point.slug !== ''"
                class="link last"
                itemprop="item"
              >
                <span class="body-m-regular" itemprop="name">{{
                  point.title
                }}</span>
              </span>
              <nuxt-link
                itemprop="item"
                v-else
                :to="point.slug ? `/${point.slug}/` : '/'"
                :alt="point.title"
                class="link"
                ><span class="body-m-regular" itemprop="name">{{
                  point.title
                }}</span></nuxt-link
              >
            </template>
            <meta itemprop="position" :content="String(index)" />
          </li>
        </ol>
      </ui-horizontal-scroll>
    </div>
  </DelayHydration>
</template>

<script setup lang="ts">
import type { Breadcrumbs } from '~/interfaces/api';

const route = useRoute();
const props = defineProps({
  data: {
    type: Array as () => Breadcrumbs,
    default: (): Breadcrumbs[] => [],
  },
});

const siteUrl = computed(() => {
  let req = '';
  if (!import.meta.env.SSR && window) {
    req = window.location.host;
  }
  return `https://${req}/`;
});

useHead(() => {
  const items = props.data.map((el, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: {
      '@id':
        siteUrl.value +
        (el.slug !== undefined
          ? el.slug + (el.slug && '/')
          : route.fullPath.slice(1)),
      name: el.title,
    },
  }));
  if (items.length) {
    items[items.length - 1].item['@id'] += '#';
  }

  return {
    script: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'http://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: items,
        },
      },
    ],
  };
});
</script>
<style lang="scss" scoped src="./breadcrumbs-scss.scss"></style>
